<template>
    <div ref="listEl" class="chat-message-list">
        <ChatMessage v-for="msg in messages" :key="msg.id" :message="msg" />
        <ChatThinkingIndicator v-if="isThinking" />
    </div>
</template>

<script setup lang="ts">
import { nextTick, ref, watch } from 'vue';
import type { Message } from '@/types/chat';
import ChatMessage from './ChatMessage.vue';
import ChatThinkingIndicator from './ChatThinkingIndicator.vue';

defineOptions({
    name: 'ChatMessageList',
});

const props = defineProps<{
    messages: Message[];
    isThinking: boolean;
}>();

const listEl = ref<HTMLElement | null>(null);

function scrollToBottom() {
    nextTick(() => {
        if (listEl.value) listEl.value.scrollTop = listEl.value.scrollHeight;
    });
}

watch(() => props.messages, scrollToBottom, { deep: true });
watch(() => props.isThinking, scrollToBottom);
</script>
